import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import qs from 'qs';
import styled from 'styled-components/macro';
import Button from '@material-ui/core/Button';

const PRODUCT_TYPE_NORMAL = 'normal';
const PRODUCT_TYPE_RS = 'rs';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
`;

const Label = styled.span`
  margin-right: 8px;
  font-weight: 600;
  font-size: 14px;
  color: #666;
`;

const StyledButton = styled(Button)`
  && {
    min-width: 0;
    text-transform: none;
  }
`;

export const buildProductTypeLink = (currentWhere, productType) => {
  const { productType: _pt, product_type: _pt2, ...rest } = currentWhere;
  const query = { ...rest, productType };
  const search = Object.keys(query).length ? `?${qs.stringify(query)}` : '';
  return search || '?';
};

const ProductTypeFilter = ({ where }) => {
  const location = useLocation();
  const current =
    where.productType || where.product_type || PRODUCT_TYPE_NORMAL;
  const basePath = location.pathname;

  return (
    <Wrapper>
      <Label>Product type:</Label>
      <StyledButton
        component={Link}
        to={`${basePath}${buildProductTypeLink(where, PRODUCT_TYPE_NORMAL)}`}
        variant={current === PRODUCT_TYPE_NORMAL ? 'contained' : 'outlined'}
        color="primary"
        size="small"
        aria-label="Contender (Mining) products"
      >
        Contender (Mining)
      </StyledButton>
      <StyledButton
        component={Link}
        to={`${basePath}${buildProductTypeLink(where, PRODUCT_TYPE_RS)}`}
        variant={current === PRODUCT_TYPE_RS ? 'contained' : 'outlined'}
        color="primary"
        size="small"
        aria-label="Reliant (Aggregates) products"
      >
        Reliant (Aggregates)
      </StyledButton>
    </Wrapper>
  );
};

export default ProductTypeFilter;
